module.exports = __webpack_public_path__ + "01_glasses_red.5ed12181.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/01_glasses_red.png
// module id = hSSN
// module chunks = 0